/**
 * Carrier to IMO (Insurance Marketplace Operator) mapping.
 * Source of truth: Monday.com "Carrier to IMO Reference" (Altura SOP & Document Hub).
 */
export var IMO;
(function (IMO) {
    IMO["PREMIER_PRODUCERS_GROUP"] = "PREMIER_PRODUCERS_GROUP";
    IMO["PINNACLE"] = "PINNACLE";
    IMO["HEARTLAND"] = "HEARTLAND";
    IMO["SMS"] = "SMS";
})(IMO || (IMO = {}));
export var Carrier;
(function (Carrier) {
    // Premier Producers Group
    Carrier["AMERICAN_AMICABLE"] = "AMERICAN_AMICABLE";
    Carrier["COREBRIDGE"] = "COREBRIDGE";
    Carrier["ELCO_MUTUAL"] = "ELCO_MUTUAL";
    Carrier["ROYAL_NEIGHBORS"] = "ROYAL_NEIGHBORS";
    Carrier["TRANSAMERICA"] = "TRANSAMERICA";
    // Premier Producers Group - Senior Market Sales
    Carrier["GERBER"] = "GERBER";
    Carrier["MUTUAL_OF_OMAHA"] = "MUTUAL_OF_OMAHA";
    // Pinnacle
    Carrier["ACCENDO"] = "ACCENDO";
    Carrier["AFLAC"] = "AFLAC";
    Carrier["AMERICAN_EQUITY"] = "AMERICAN_EQUITY";
    Carrier["AMERICAN_HOME_LIFE"] = "AMERICAN_HOME_LIFE";
    Carrier["AMERICO"] = "AMERICO";
    Carrier["ASSURITY_LIFE"] = "ASSURITY_LIFE";
    Carrier["AXONIC"] = "AXONIC";
    Carrier["HARBOURVIEW"] = "HARBOURVIEW";
    Carrier["NATIONWIDE"] = "NATIONWIDE";
    Carrier["NATIONAL_LIFE_GROUP"] = "NATIONAL_LIFE_GROUP";
    Carrier["NORTH_AMERICAN"] = "NORTH_AMERICAN";
    Carrier["UNITED_HOME_LIFE"] = "UNITED_HOME_LIFE";
    // Heartland Financial
    Carrier["ATHENE"] = "ATHENE";
    Carrier["BALTIMORE_LIFE"] = "BALTIMORE_LIFE";
    Carrier["COMBINED"] = "COMBINED";
    Carrier["FORESTERS"] = "FORESTERS";
    Carrier["F_AND_G"] = "F_AND_G";
    // Heartland National
    Carrier["ILLINOIS_MUTUAL"] = "ILLINOIS_MUTUAL";
    Carrier["INSTABRAIN"] = "INSTABRAIN";
    Carrier["KANSAS_CITY_LIFE"] = "KANSAS_CITY_LIFE";
    Carrier["LIBERTY_BANKERS"] = "LIBERTY_BANKERS";
    Carrier["ROYAL_ARCANUM"] = "ROYAL_ARCANUM";
    Carrier["SILAC"] = "SILAC";
})(Carrier || (Carrier = {}));
export const CARRIER_TO_IMO = {
    // Premier Producers Group
    [Carrier.AMERICAN_AMICABLE]: IMO.PREMIER_PRODUCERS_GROUP,
    [Carrier.COREBRIDGE]: IMO.PREMIER_PRODUCERS_GROUP,
    [Carrier.ELCO_MUTUAL]: IMO.PREMIER_PRODUCERS_GROUP,
    [Carrier.ROYAL_NEIGHBORS]: IMO.PREMIER_PRODUCERS_GROUP,
    [Carrier.TRANSAMERICA]: IMO.PREMIER_PRODUCERS_GROUP,
    // Senior Market Sales
    [Carrier.GERBER]: IMO.SMS,
    [Carrier.MUTUAL_OF_OMAHA]: IMO.SMS,
    // Pinnacle (SpotSign — pfsinsurance.com/spot)
    [Carrier.ACCENDO]: IMO.PINNACLE,
    [Carrier.AFLAC]: IMO.PINNACLE,
    [Carrier.AMERICAN_EQUITY]: IMO.PINNACLE,
    [Carrier.AMERICAN_HOME_LIFE]: IMO.PINNACLE,
    [Carrier.AMERICO]: IMO.PINNACLE,
    [Carrier.ASSURITY_LIFE]: IMO.PINNACLE,
    [Carrier.AXONIC]: IMO.PINNACLE,
    [Carrier.HARBOURVIEW]: IMO.PINNACLE,
    [Carrier.NATIONWIDE]: IMO.PINNACLE,
    [Carrier.NATIONAL_LIFE_GROUP]: IMO.PINNACLE,
    [Carrier.NORTH_AMERICAN]: IMO.PINNACLE,
    [Carrier.UNITED_HOME_LIFE]: IMO.PINNACLE,
    // Heartland (Reagan.ai — Heartland Financial + Heartland National)
    [Carrier.ATHENE]: IMO.HEARTLAND,
    [Carrier.BALTIMORE_LIFE]: IMO.HEARTLAND,
    [Carrier.COMBINED]: IMO.HEARTLAND,
    [Carrier.FORESTERS]: IMO.HEARTLAND,
    [Carrier.F_AND_G]: IMO.HEARTLAND,
    [Carrier.ILLINOIS_MUTUAL]: IMO.HEARTLAND,
    [Carrier.INSTABRAIN]: IMO.HEARTLAND,
    [Carrier.KANSAS_CITY_LIFE]: IMO.HEARTLAND,
    [Carrier.LIBERTY_BANKERS]: IMO.HEARTLAND,
    [Carrier.ROYAL_ARCANUM]: IMO.HEARTLAND,
    [Carrier.SILAC]: IMO.HEARTLAND,
};
export const IMO_CARRIERS = {
    [IMO.PREMIER_PRODUCERS_GROUP]: [
        Carrier.AMERICAN_AMICABLE,
        Carrier.COREBRIDGE,
        Carrier.ELCO_MUTUAL,
        Carrier.ROYAL_NEIGHBORS,
        Carrier.TRANSAMERICA,
    ],
    [IMO.SMS]: [
        Carrier.GERBER,
        Carrier.MUTUAL_OF_OMAHA,
    ],
    [IMO.PINNACLE]: [
        Carrier.ACCENDO,
        Carrier.AFLAC,
        Carrier.AMERICAN_EQUITY,
        Carrier.AMERICAN_HOME_LIFE,
        Carrier.AMERICO,
        Carrier.ASSURITY_LIFE,
        Carrier.AXONIC,
        Carrier.HARBOURVIEW,
        Carrier.NATIONWIDE,
        Carrier.NATIONAL_LIFE_GROUP,
        Carrier.NORTH_AMERICAN,
        Carrier.UNITED_HOME_LIFE,
    ],
    [IMO.HEARTLAND]: [
        Carrier.ATHENE,
        Carrier.BALTIMORE_LIFE,
        Carrier.COMBINED,
        Carrier.FORESTERS,
        Carrier.F_AND_G,
        Carrier.ILLINOIS_MUTUAL,
        Carrier.INSTABRAIN,
        Carrier.KANSAS_CITY_LIFE,
        Carrier.LIBERTY_BANKERS,
        Carrier.ROYAL_ARCANUM,
        Carrier.SILAC,
    ],
};
/**
 * Display names for carriers
 */
export const CARRIER_DISPLAY_NAMES = {
    [Carrier.AMERICAN_AMICABLE]: "American Amicable",
    [Carrier.COREBRIDGE]: "Corebridge",
    [Carrier.ELCO_MUTUAL]: "ELCO Mutual",
    [Carrier.ROYAL_NEIGHBORS]: "Royal Neighbors",
    [Carrier.TRANSAMERICA]: "Transamerica",
    [Carrier.GERBER]: "Gerber",
    [Carrier.MUTUAL_OF_OMAHA]: "Mutual of Omaha",
    [Carrier.ACCENDO]: "Accendo",
    [Carrier.AFLAC]: "Aflac",
    [Carrier.AMERICAN_EQUITY]: "American Equity",
    [Carrier.AMERICAN_HOME_LIFE]: "American Home Life",
    [Carrier.AMERICO]: "Americo",
    [Carrier.ASSURITY_LIFE]: "Assurity Life",
    [Carrier.AXONIC]: "Axonic",
    [Carrier.HARBOURVIEW]: "Harbourview",
    [Carrier.NATIONWIDE]: "Nationwide",
    [Carrier.NATIONAL_LIFE_GROUP]: "National Life Group",
    [Carrier.NORTH_AMERICAN]: "North American",
    [Carrier.UNITED_HOME_LIFE]: "United Home Life",
    [Carrier.ATHENE]: "Athene",
    [Carrier.BALTIMORE_LIFE]: "Baltimore Life",
    [Carrier.COMBINED]: "Combined",
    [Carrier.FORESTERS]: "Foresters",
    [Carrier.F_AND_G]: "F&G",
    [Carrier.ILLINOIS_MUTUAL]: "Illinois Mutual",
    [Carrier.INSTABRAIN]: "InstaBrain",
    [Carrier.KANSAS_CITY_LIFE]: "Kansas City Life",
    [Carrier.LIBERTY_BANKERS]: "Liberty Bankers",
    [Carrier.ROYAL_ARCANUM]: "Royal Arcanum",
    [Carrier.SILAC]: "SILAC",
};
/** Stable ordering when a submission spans multiple IMOs (primary = first match). */
export const IMO_DETECTION_ORDER = [
    IMO.PINNACLE,
    IMO.PREMIER_PRODUCERS_GROUP,
    IMO.HEARTLAND,
    IMO.SMS,
];
/** Form carrier slug (e.g. `american_amicable`) → IMO */
export const CARRIER_SLUG_TO_IMO = Object.fromEntries(Object.entries(CARRIER_TO_IMO).map(([carrier, imo]) => [
    carrier.toLowerCase(),
    imo,
]));
/** Form carrier slug → Carrier enum value */
export const CARRIER_SLUG_TO_CARRIER = Object.fromEntries(Object.entries(CARRIER_TO_IMO).map(([carrier]) => [
    carrier.toLowerCase(),
    carrier,
]));
/** Unique IMOs for selected carrier slugs, in {@link IMO_DETECTION_ORDER}. */
export function detectIMOs(carrierSlugs) {
    const found = new Set();
    for (const slug of carrierSlugs) {
        const imo = CARRIER_SLUG_TO_IMO[slug];
        if (imo)
            found.add(imo);
    }
    return IMO_DETECTION_ORDER.filter((imo) => found.has(imo));
}
/** Primary IMO for routing — first entry from {@link detectIMOs}. */
export function primaryImo(carrierSlugs) {
    return detectIMOs(carrierSlugs)[0];
}
export function carrierSlugsForImo(imo, carrierSlugs) {
    return carrierSlugs.filter((slug) => CARRIER_SLUG_TO_IMO[slug] === imo);
}
export function hasImo(carrierSlugs, imo) {
    return carrierSlugs.some((slug) => CARRIER_SLUG_TO_IMO[slug] === imo);
}
